import script from "./requestList.vue?vue&type=script&setup=true&lang=js"
export * from "./requestList.vue?vue&type=script&setup=true&lang=js"

import "./requestList.vue?vue&type=style&index=0&id=6017f7c5&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6017f7c5"]])

export default __exports__